import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LocalStorageUtil } from 'src/app/util/local-storage-util';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    const account = LocalStorageUtil.getAccountInfo();
    if (account.admin) {
      return true;
    } else {
      this.router.navigate(['/patients']);
      return false;
    }
  }
}